export const SHOW_IN_APP_VIDEOS = 'SHOW_IN_APP_VIDEOS';
export const HIDE_IN_APP_VIDEOS = 'HIDE_IN_APP_VIDEOS';